import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { GridToolbar } from "@mui/x-data-grid";

import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { GlobalState } from "context/GlobalContext";

import axios from "axios";

import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import ClearRounded from "@mui/icons-material/ClearRounded";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DownloadIcon from "@mui/icons-material/Download";
import EditModal from "./EditModal/EditModal";
import { inputTypes } from "data/pimData";

const inputColumns = {
	ginesys_store_name: {
		name: "Ginesys Store Name",
		key: "full_name",
		group: "EBO_STORE_POS",
		type: { notNull: true, datatype: "string", unique: true },
		input_type: inputTypes.autoGenerate,
		display: true,
	},
	short_name: {
		name: "Store Short Name",
		key: "short_name",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.autoGenerate,
		display: true,
	},
	store_code: {
		name: "Store Code",
		key: "site_code",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.autoGenerate,
		display: true,
	},
	fofo_code: {
		name: "Fofo Code",
		key: "fofo_code",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.autoGenerate,
		display: true,
	},
	upi_id_1: {
		name: "UPI Id 1",
		key: "upi_id_1",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.enter,
		display: true,
	},
	upi_id_2: {
		name: "UPI Id 2",
		key: "upi_id_2",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.enter,
		display: true,
	},
	hdfc_card_tid_1: {
		name: "HDFC Card TID 1",
		key: "card_tid_1",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.enter,
		display: true,
	},
	hdfc_card_tid_2: {
		name: "HDFC Card TID 2",
		key: "card_tid_2",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.enter,
		display: true,
	},
	amex_id: {
		name: "Amex Id",
		key: "amex_id",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.enter,
		display: true,
	},
	writer_cash_pickup: {
		name: "Writer Cash Pickup",
		key: "writer_cash_pickup",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.enter,
		display: true,
	},
	phonepe_id: {
		name: "Phonepe Id",
		key: "phonepe_id",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.enter,
		display: true,
	},
	pay_by_link: {
		name: "Pay By Link",
		key: "pay_by_link",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.enter,
		display: true,
	},
	magicpin_id: {
		name: "Magicpin ID",
		key: "magicpin_id",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.enter,
		display: true,
	},
	zomato_id: {
		name: "Zomato ID",
		key: "zomato_id",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.enter,
		display: true,
	},
	status: {
		name: "Status",
		key: "Status",
		group: "EBO_STORE_POS",
		type: { notNull: false, datatype: "string", unique: false },
		input_type: inputTypes.enter,
		display: true,
	},
};

const tableColumns = [
	...Object.keys(inputColumns).map((col) => {
		return {
			field: inputColumns[col].key,
			headerName: inputColumns[col].name,
			flex: 1,
			minWidth: 150,
			headerAlign: "center",
			align: "center",
		};
	}),
];

const StoreTidMaster = () => {
	const [allStores, setAllStores] = useState([]);
	const [loading, setLoading] = useState(false);
	const [selectedStore, setSelectedStore] = useState();

	// def value is true becoz for textfield disabled =true;
	const [modalOpen, setModalOpen] = useState(false);
	const { setSnackBar, snackBar, setSnackBarOpen } = GlobalState();

	// console.log(selectedStore, allStores);
	const submitFunction = () => {};
	// fetch costings on load
	useEffect(() => {
		const fetchStores = async () => {
			try {
				setLoading(true);
				const { data } = await axios.get("/api/pos_reco/get_store_master_bq");
				setAllStores(data);
				setLoading(false);
			} catch (error) {
				setLoading(false);
				setSnackBarOpen(true);
				setSnackBar({
					message: "Network Error",
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			}
		};

		fetchStores();
	}, []);

	const handleGridRowClick = (data) => {
		setModalOpen(true);
		setSelectedStore(data);
	};
	return (
		<Box sx={{ width: "100%", height: "100%" }}>
			<Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, pr: 1 }}>
				<Box display="flex" gap={1}>
					<Button size="small" variant="contained" startIcon={<UploadFileIcon />}>
						Upload
					</Button>
					<Button size="small" variant="outlined" startIcon={<DownloadIcon />}>
						Download
					</Button>
				</Box>
			</Box>
			<DataGrid
				rows={allStores}
				columns={tableColumns}
				sx={{
					height: "calc(101vh - 180px)",
					width: "100%",
					border: "none",
					"& .MuiDataGrid-root": {
						border: "none",
					},
					"& .MuiDataGrid-cell": {
						borderBottom: "1px solid #f0f0f0",
						padding: "6px 12px",
						fontSize: "13px",
					},
					"& .MuiDataGrid-columnHeaders": {
						backgroundColor: "#fafafa",
						borderBottom: "2px solid #e0e0e0",
						fontWeight: 700,
						height: "48px",
					},
					"& .MuiDataGrid-row": {
						cursor: "pointer",
						height: "40px",
						"&:hover": {
							backgroundColor: "#f5f5f5",
						},
					},
					"& .MuiDataGrid-columnSeparator": {
						display: "none",
					},
					"& .MuiDataGrid-footerContainer": {
						borderTop: "2px solid #e0e0e0",
						backgroundColor: "#fafafa",
						height: "52px",
					},
				}}
				onRowClick={(params) => {
					handleGridRowClick(params.row);
				}}
				initialState={{
					pagination: {
						paginationModel: { pageSize: 25 },
					},
				}}
				loading={loading}
				slots={{
					noRowsOverlay: () => (
						<Typography variant="body2" sx={{ mt: 2 }}>
							No stores found
						</Typography>
					),
				}}
				density="compact"
				getRowId={(row) => row[inputColumns.short_name.key]}
				disableRowSelectionOnClick
				pageSizeOptions={[10, 25, 50]}
			/>
			{/* edit Store Data */}
			<EditModal
				columns={inputColumns}
				allStores={allStores}
				setAllStores={setAllStores}
				selectedStore={selectedStore}
				setSelectedStore={setSelectedStore}
				modalOpen={modalOpen}
				setModalOpen={setModalOpen}
				submitFunction={submitFunction}
			/>
		</Box>
	);
};

export default StoreTidMaster;
